import { Inject, Injectable, Injector } from '@angular/core';
import { environment } from '../environments/environment';
import { EAssignmentMode } from './common-interfaces';

import { OperationAssignmentsService } from './operation-assignments.service';
import { UtilsService } from './utils.service';

import { Utilities_OperationService } from './Utilities.operation.service';
import { PurchaseOrders_OperationService } from './PurchaseOrders.operation.service';
import { Materials_OperationService } from './Materials.operation.service';
import { SalesOrders_OperationService } from './SalesOrders.operation.service';
import { Notifications_OperationService } from './Notifications.operation.service';
import { Inventory_OperationService } from './Inventory.operation.service';
import { FootprintApiManager_OperationService } from './FootprintApiManager.operation.service';
import { Reports_OperationService } from './Reports.operation.service';
import { FootprintEdi_OperationService } from './FootprintEdi.operation.service';


@Injectable({ providedIn: 'root' })
export class app_OperationService {

  constructor(
    private injector: Injector,
    private $utils: UtilsService,
    private operationAssignmentsService: OperationAssignmentsService,
  ) {
    this.Utilities = this.injector.get(Utilities_OperationService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_OperationService);
    this.Materials = this.injector.get(Materials_OperationService);
    this.SalesOrders = this.injector.get(SalesOrders_OperationService);
    this.Notifications = this.injector.get(Notifications_OperationService);
    this.Inventory = this.injector.get(Inventory_OperationService);
    this.FootprintApiManager = this.injector.get(FootprintApiManager_OperationService);
    this.Reports = this.injector.get(Reports_OperationService);
    this.FootprintEdi = this.injector.get(FootprintEdi_OperationService);
  }

  public Utilities: Utilities_OperationService;
  public PurchaseOrders: PurchaseOrders_OperationService;
  public Materials: Materials_OperationService;
  public SalesOrders: SalesOrders_OperationService;
  public Notifications: Notifications_OperationService;
  public Inventory: Inventory_OperationService;
  public FootprintApiManager: FootprintApiManager_OperationService;
  public Reports: Reports_OperationService;
  public FootprintEdi: FootprintEdi_OperationService;
  public app: app_OperationService = this;


  isAssigned(operationName: string, mode: EAssignmentMode): Promise<boolean> {
    var referenceName = null;    
    return Promise.resolve(this.operationAssignmentsService.isAssigned(referenceName, operationName, mode));
  }
}
